import DefectData from "./defectData";
import { FilterItem } from "../api/Types";
import { FilterCondition } from "../constants/Enums";
import { ExpandableKeys } from "./core";

class AllDefectData extends DefectData {
  filterItems: FilterItem[] = [
    {
      fieldName: "isValid",
      value: false,
      condition: FilterCondition.Equal,
    },
    {
      fieldName: "eventTypeId",
      value: 3,
      condition: FilterCondition.NotEqual,
    },
    {
      fieldName: "incidentStatusId",
      value: 0,
      valueTo: 8,
      condition: FilterCondition.Between,
    },
  ];
  selectedRows = new ExpandableKeys();
  constructor() {
    super();
  }
}

const allDefectDataStore = new AllDefectData();
export default allDefectDataStore;
